<template>
  <tile class='opc-zmone'>
    <div class='opc-zm-base-card__head'>
      <div class='opc-zm-base-card__head-left'>
        <img class='opc-zm-base-card__logo' :src='logo' :alt='title' tabindex='-1' />
      </div>
      <div class='opc-zm-base-card__head-right'>
        <h2 class='opc-zm-base-card__name text-capitalize'>
          {{ $t('billing.planform.title.zoom_one_pro') }}
          <i class='zm-icon-success main-icon' aria-hidden='true'></i>
        </h2>
        <div class='opc-zm-base-card__collapse opc-zm-base-card__collapse--reset'>
          <span>{{ $t('billing.single_use_meeting.desc') }}</span>
        </div>
      </div>
    </div>
  </tile>
</template>
<script>
import logo from '@/assets/plans/icon_ZM.svg';
import Tile from '@/components/tile.vue';
export default {
  name: 'SingleUsePro',
  components: { Tile },
  data() {
    return {
      logo,
    };
  },
};
</script>
